import "@arco-design/web-react/es/Button/style";
import _Button from "@arco-design/web-react/es/Button";
import React, { Suspense } from 'react';
// Lazy load the real component
const RealExportModal = /*#__PURE__*/React.lazy(() => import('./ExportModal').then(module => ({
  default: module.ExportModal
})));
export const ExportModal = props => {
  const {
    buttonText = '数据导出',
    buttonType = 'primary',
    buttonStatus = 'default'
  } = props;
  return /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement(_Button, {
      loading: true,
      type: buttonType,
      status: buttonStatus
    }, buttonText)
  }, /*#__PURE__*/React.createElement(RealExportModal, props));
};